import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';

export const offlineInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      // 504 is the Service Worker Timeout (Gateway Timeout)
      if (error.status === 504) {
        console.warn('PWA: Service Worker timed out. Device is likely offline.');
        // Optional: Return an empty object or custom error to prevent a crash
      }
      return throwError(() => error);
    }),
  );
};
